module.exports = __webpack_public_path__ + "~@/assets/img/white-135-35.25659ef8.svg";